import React from 'react'
import './NotFound.scss'

import Header from '../../components/Header/Header'
import UnderHeader from '../../components/UnderHeader/UnderHeader'
import Footer from '../../components/Footer/Footer'
import LogoPartner from '../../components/LogoPartner/LogoPartner'
import PageTitle from '../../components/PageTitle/PageTitle'

import pic404 from '../../assets/Pictures/404.png'
import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <>
      <Header page={''} />
      <UnderHeader className={'products'} />
      <PageTitle mainTitle={'NOT FOUND!'} page={'NOT FOUND!'} />
      <img src={pic404} alt="" />
      <div className='notFound'>
        Not Found, Sorry!
      </div>
      <div className='notFoundButton'>
        <Link to='/'>Back to home</Link>
      </div>
      <LogoPartner />
      <Footer />
    </>
  )
}
